import { css, keyframes } from '@emotion/core';
import media from 'css-in-js-media';

// keyframe animations for ImagesContentBand sections
const animation11 = keyframes`
  0% {
    opacity: 0;
    transform: translateY(200px);
  }

  12.5% {
    opacity: 1;
    transform: translateY(0);
  }

  25% {
    opacity: 1;
    transform: translateY(0);
  }

  37.5% {
    opacity: 0;
    transform: translateY(-200px);
  }

  50% {
    opacity: 0;
    transform: translateY(-200px);
  }

  62.5% {
    opacity: 0;
    transform: translateY(-200px);
  }

  75% {
    opacity: 0;
    transform: translateY(-200px);
  }

  87.5% {
    opacity: 0;
    transform: translateY(-200px);
  }

  100% {
    opacity: 0;
    transform: translateY(-200px);
  }
`;

const animation12 = keyframes`
  0% {
    opacity: 0;
    transform: translateY(200px);
  }

  12.5% {
    opacity: 0;
    transform: translateY(200px);
  }

  25% {
    opacity: 1;
    transform: translateY(0);
  }

  37.5% {
    opacity: 1;
    transform: translateY(0);
  }

  50% {
    opacity: 0;
    transform: translateY(-200px);
  }

  62.5% {
    opacity: 0;
    transform: translateY(-200px);
  }

  75% {
    opacity: 0;
    transform: translateY(-200px);
  }

  87.5% {
    opacity: 0;
    transform: translateY(-200px);
  }

  100% {
    opacity: 0;
    transform: translateY(-200px);
  }
`;

const animation13 = keyframes`
  0% {
    opacity: 0;
    transform: translateY(200px);
  }

  12.5% {
    opacity: 0;
    transform: translateY(200px);
  }

  25% {
    opacity: 0;
    transform: translateY(200px);
  }

  37.5% {
    opacity: 0;
    transform: translateY(200px);
  }

  50% {
    opacity: 0;
    transform: translateY(200px);
  }

  62.5% {
    opacity: 1;
    transform: translateY(0);
  }

  75% {
    opacity: 1;
    transform: translateY(0);
  }

  87.5% {
    opacity: 0;
    transform: translateY(-200px);
  }

  100% {
    opacity: 0;
    transform: translateY(-200px);
  }
`;

const animation14 = keyframes`
  0% {
    opacity: 0;
    transform: translateY(200px);
  }

  12.5% {
    opacity: 0;
    transform: translateY(200px);
  }

  25% {
    opacity: 0;
    transform: translateY(200px);
  }

  37.5% {
    opacity: 0;
    transform: translateY(200px);
  }

  50% {
    opacity: 0;
    transform: translateY(200px);
  }

  62.5% {
    opacity: 0;
    transform: translateY(200px);
  }

  75% {
    opacity: 1;
    transform: translateY(0);
  }

  87.5% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(-200px);
  }
`;

const animation21 = keyframes`
  0% {
    opacity: 0;
    transform: rotate(15deg);
  }

  12.5% {
    opacity: 1;
    transform: rotate(0);
  }

  25% {
    opacity: 1;
    transform: rotate(0);
  }

  37.5% {
    opacity: 1;
    transform: rotate(0);
  }

  50% {
    opacity: 1;
    transform: rotate(0);
  }

  62.5% {
    opacity: 0;
    transform: rotate(-15deg);
  }

  75% {
    opacity: 0;
    transform: rotate(-15deg);
  }

  87.5% {
    opacity: 0;
    transform: rotate(-15deg);
  }

  100% {
    opacity: 0;
    transform: rotate(-15deg);
  }
`;

const animation22 = keyframes`
  0% {
    opacity: 0;
    transform: rotate(15deg);
  }

  12.5% {
    opacity: 0;
    transform: rotate(15deg);
  }

  25% {
    opacity: 1;
    transform: rotate(0);
  }

  37.5% {
    opacity: 1;
    transform: rotate(0);
  }

  50% {
    opacity: 1;
    transform: rotate(0);
  }

  62.5% {
    opacity: 1;
    transform: rotate(0);
  }

  75% {
    opacity: 0;
    transform: rotate(-15deg);
  }

  87.5% {
    opacity: 0;
    transform: rotate(-15deg);
  }

  100% {
    opacity: 0;
    transform: rotate(-15deg);
  }
`;

const animation23 = keyframes`
  0% {
    opacity: 0;
    transform: rotate(15deg);
  }

  12.5% {
    opacity: 0;
    transform: rotate(15deg);
  }

  25% {
    opacity: 0;
    transform: rotate(15deg);
  }

  37.5% {
    opacity: 1;
    transform: rotate(0);
  }

  50% {
    opacity: 1;
    transform: rotate(0);
  }

  62.5% {
    opacity: 1;
    transform: rotate(0);
  }

  75% {
    opacity: 1;
    transform: rotate(0);
  }

  87.5% {
    opacity: 0;
    transform: rotate(-15deg);
  }

  100% {
    opacity: 0;
    transform: rotate(-15deg);
  }
`;

const animation24 = keyframes`
  0% {
    opacity: 0;
    transform: rotate(15deg);
  }

  12.5% {
    opacity: 0;
    transform: rotate(15deg);
  }

  25% {
    opacity: 0;
    transform: rotate(15deg);
  }

  37.5% {
    opacity: 0;
    transform: rotate(15deg);
  }

  50% {
    opacity: 1;
    transform: rotate(0);
  }

  62.5% {
    opacity: 1;
    transform: rotate(0);
  }

  75% {
    opacity: 1;
    transform: rotate(0);
  }

  87.5% {
    opacity: 1;
    transform: rotate(0);
  }

  100% {
    opacity: 0;
    transform: rotate(-15deg);
  }
`;

const animation3n = keyframes`
  0% {
    transform: translateX(0);
  }

  33.33% {
    transform: translateX(40px);
  }

  66.66% {
    transform: translateX(-40px);
  }

  100% {
    transform: translateX(0);
  }
`;

export const styledAnimations = css`
  margin-top: 64px;
  padding-top: 64px;
  overflow: hidden;
  position: relative;

  ${media('< tablet')} {
    margin-top: 0;
    min-height: 300px;
  }

  // first ImagesContentBand Animations
  .MongoDBAnimation1-1,
  .MongoDBAnimation1-2,
  .MongoDBAnimation1-3,
  .MongoDBAnimation1-4 {
    animation: 10s ease-in-out infinite;
    position: absolute;
  }

  .MongoDBAnimation1-1,
  .MongoDBAnimation1-3 {
    left: 8%;
  }

  .MongoDBAnimation1-2,
  .MongoDBAnimation1-4 {
    right: 8%;
  }

  .MongoDBAnimation1-1 {
    animation-name: ${animation11};
  }

  .MongoDBAnimation1-2 {
    animation-name: ${animation12};
  }

  .MongoDBAnimation1-3 {
    animation-name: ${animation13};
  }

  .MongoDBAnimation1-4 {
    animation-name: ${animation14};
  }

  // second ImagesContentBand Animations
  .MongoDBAnimation2-1,
  .MongoDBAnimation2-2,
  .MongoDBAnimation2-3,
  .MongoDBAnimation2-4 {
    animation: 6s ease-in-out infinite;
    transform-origin: left center;
  }

  .MongoDBAnimation2-1 {
    animation-name: ${animation21};
  }

  .MongoDBAnimation2-2 {
    animation-name: ${animation22};
  }

  .MongoDBAnimation2-3 {
    animation-name: ${animation23};
  }

  .MongoDBAnimation2-4 {
    animation-name: ${animation24};
  }

  // third ImagesContentBand Animations
  .MongoDBAnimation3-1 {
    height: 160px;
    width: 100%;
  }

  .MongoDBAnimation3-2,
  .MongoDBAnimation3-3,
  .MongoDBAnimation3-5 {
    animation: ${animation3n} 16s ease infinite;
    position: absolute;
  }

  .MongoDBAnimation3-2,
  .MongoDBAnimation3-3 {
    top: 0;
  }

  .MongoDBAnimation3-2 {
    left: 60px;
  }

  .MongoDBAnimation3-3,
  .MongoDBAnimation3-5 {
    right: 60px;
  }

  .MongoDBAnimation3-5 {
    bottom: 0;
  }

  .MongoDBAnimation3-3 {
    animation-delay: 6s;
  }

  .MongoDBAnimation3-5 {
    animation-delay: 12s;
  }
`;

export const styledSubheading = css`
  text-align: center;
  margin: 10px auto 0 auto !important;
`;

export const styledHeading = css`
  line-height: 1.2;
  margin: 64px auto 0 auto !important;

  ul {
    font-size: 18px;
    margin-left: 32px;
    margin-top: 10px;
  }

  ${media('< tablet')} {
    margin: 20px auto 0 auto;
    text-align: center;
    width: 100%;
  }
`;

export const styledContainerHeading = css`
  margin: 0 !important;
  text-align: center;

  ${media('< tablet')} {
    margin: 0 auto !important;
  }
`;

export const styledImagesContent = css`
  padding-bottom: 0;
  padding-top: 0;

  p {
    color: #5b6987;
    margin: 20px 0 0 0;

    ${media('< desktop')} {
      margin: 20px auto 0 auto;
      text-align: center;
      width: 100%;
    }
  }
`;

export const styledLink = css`
  display: block;
  margin-top: 20px !important;

  ${media('< tablet')} {
    display: block;
    margin: 20px auto 0 auto;
    text-align: center;
    width: 80%;
  }
`;

export const styledContentWrapper = css`
  margin-top: 64px;
`;

export const styledContentColumn = css`
  display: flex;
  flex-direction: column;
  justify-content: center;

  div.subtitle {
    margin-top: 16px !important;
  }

  p {
    margin-top: 0 !important;
  }

  ${media('<desktop')} {
    text-align: center;
    margin: auto;
  }
`;
